import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import ThumbnailPicture from '@adsk/bim360-matrix-react-thumbnail-picture';

class IssuePreviewDetailsTabAttachment extends PureComponent {
  constructor(props) {
    super(props);

    this.onThumbnailClick = this.onThumbnailClick.bind(this);
  }

  onThumbnailClick() {
    this.props.onClickThumbnail();
  }

  render() {
    const {thumbnail} = this.props;

    const thumbnailProps = {
      src: thumbnail && thumbnail.attachmentUrl,
      onClick: this.onThumbnailClick,
      error: !thumbnail
    };

    return (
      <div className="IssuePreviewDetailsTabAttachment">
        <ThumbnailPicture className="IssuePreviewDetailsTabAttachment__thumbnail" picture={thumbnailProps} hideLabel />
      </div>
    );
  }
}

IssuePreviewDetailsTabAttachment.propTypes = {
  thumbnail: PropTypes.object,
  onClickThumbnail: PropTypes.func.isRequired
};

IssuePreviewDetailsTabAttachment.displayName = 'IssuePreviewDetailsTabAttachment';

export default IssuePreviewDetailsTabAttachment;
